import { Link } from 'react-router-dom';
import { useTranslations } from '@/hooks/useTranslations';

interface CheckoutHeaderProps {
  step?: number;
}

export default function CheckoutHeader({ step = 1 }: CheckoutHeaderProps) {
  const { t } = useTranslations();
  const STEPS = [t('checkout.step_cart'), t('checkout.step_checkout'), t('checkout.step_complete')];

  return (
    <header className="bg-[#37368E]">
      <div className="container py-3 md:py-4">
        {/* Mobile: logo centered on top, steps below */}
        <div className="flex flex-col items-center gap-3 md:flex-row md:justify-between">
          <Link to="/" className="md:flex-shrink-0">
            <img
              src="/logo-white.png"
              alt="Logo"
              width="163"
              height="40"
              className="h-8 md:h-10 w-auto object-contain"
              style={{ aspectRatio: '1157 / 284' }}
              decoding="async"
              fetchPriority="high"
            />
          </Link>

          {/* Steps – always show labels */}
          <div className="flex items-center gap-0">
            {STEPS.map((label, idx) => (
              <div key={label} className="flex items-center">
                <div className="flex flex-col items-center">
                  <div
                    className={`flex h-6 w-6 md:h-7 md:w-7 items-center justify-center rounded-full text-[10px] md:text-xs font-bold ${
                      idx <= step
                        ? 'bg-white text-[#37368E]'
                        : 'bg-white/20 text-white/60'
                    }`}
                  >
                    {idx < step ? '✓' : idx + 1}
                  </div>
                  <span
                    className={`mt-1 text-[10px] font-medium ${
                      idx <= step ? 'text-white' : 'text-white/60'
                    }`}
                  >
                    {label}
                  </span>
                </div>
                {idx < STEPS.length - 1 && (
                  <div
                    className={`mx-2 md:mx-3 h-0.5 w-8 md:w-12 ${
                      idx < step ? 'bg-white' : 'bg-white/20'
                    }`}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </header>
  );
}
